import React, { Component } from 'react';
import Config from './Config.js';
import store from 'store';

import { Link ,Redirect } from 'react-router-dom';

class Login extends Component {

  constructor(props){
    super(props);

    this.state = {
      username : '',
      password : '',
      next : ''
    }

    this.login = this.login.bind(this);
  }

  login(){

    if(this.state.username === ""){
      alert("The username and password is incorrect.\nชื่อบัญชี หรือ รหัสผ่านไม่ถูกต้อง");
    }else if(this.state.password === ""){
      alert("The username and password is incorrect.\nชื่อบัญชี หรือ รหัสผ่านไม่ถูกต้อง");
    }else{
      let url = Config.SERVER_URL + Config.API_LOGIN +'?phoneNumOrEmail='+this.state.username+'&password='+this.state.password;

      fetch(url, {
         method: 'POST',
         headers: {
           'Accept': 'application/json',
           'Content-Type': 'application/json',
         },
      })
      .then((response) =>     response.json())
      .then((responseJson) => {

        if(responseJson.Result){

          store.set(Config.TOKEN, responseJson.token);

          this.setState({next: "resultlist"});

        }else if(responseJson.Result === undefined){
          alert(responseJson.Message);
        }else{

          alert(responseJson.ResultMessage);
        }

      })
      .catch((error) => {

      });
    }
  }

  render() {

    if(store.get(Config.TOKEN)) {
      console.log('Already logged in, redirecting to ResultList')
      return <Redirect to='/resultlist'/>;
    }

    if(this.state.next === "resultlist"){
      return <Redirect to='/resultlist'/>;
    }

    return(
      <div className='container' style={{backgroundColor: 'rgb(220, 224, 239)'}}>
        <div style={{height: 70}}/>
        <div className="row">
          <div className="col-md-4 col-md-offset-4" style={{overflow: 'hidden' ,backgroundColor: 'white' , textAlign:'center' , borderRadius: 5,paddingLeft: 0 , paddingRight:0 }}>

        		<div style={{ padding: 15,backgroundColor: 'rgb(68 ,53 ,109)' ,height:60}}>
        			<font style={{color:'white',textAlign: 'center'}}><h5>LOGIN TO YOUR ACCOUNT</h5></font>
          	</div>

          	<div style={{height: 27}} />

          	<div>
          		<img src={require('../assets/img/logo.png')} style={{width:214 ,height:58}} alt="login"/>
          	</div>

          	<div style={{height: 26}} />

          	<div>
              <input type="text" placeholder="Email/ Telephone number"
                style={{borderRadius:4,width:315 ,height:49 ,
                  paddingLeft: 10, paddingRight:10 ,
                  backgroundColor:'rgb(236 ,240 ,241)'}}
                value={this.state.username}
                onChange={(event) => { this.setState({username :event.target.value })}}
                />
          	</div>

          	<div style={{height: 13}} />

          	<div>
              <input type="password" placeholder="Password"
                style={{borderRadius:4,width:315 ,height:49 ,
                  paddingLeft: 10, paddingRight:10 ,
                  backgroundColor:'rgb(236 ,240 ,241)'}}
                value={this.state.password}
                onEnter={this.login}
                onChange={(event) => { this.setState({password :event.target.value })}}
                />
          	</div>

            <div style={{height: 10}} />

            <Link to="/forgetPassword"><h6 style={{color: 'grey'}}>Forgot Password?</h6></Link>

            <button onClick={this.login}
              style={{height: 49,width:315, borderRadius: 4,color: 'white',background: "linear-gradient(#41b9ce, #58488b)"}}>
              LOGIN NOW
            </button>

          	<div style={{height: 6}} />

            <Link to="/register">
              <button
                style={{height: 49,width:315, borderRadius: 4,color: 'white',
                  background: "rgb(68 ,53 ,109)"}} >
                REGISTER
              </button>
            </Link>


          	<div style={{height: 20}} />

        </div>
      </div>
    </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js